export const AGENT_AUTH_ROUTE = '/auth';
